'use client';

import React, { ReactNode, useRef, useEffect } from 'react';
import styles from './ShippingLabel.module.css';

interface ShippingLabelProps {
  className?: string;
  mcf?: boolean;
  content: ReactNode;
  justContent?: boolean;
  isMinEstimate?: boolean;
}

// Component implementation
const ShippingLabelBase = ({
  className,
  mcf = false,
  content,
  justContent = false,
  isMinEstimate = false,
}: ShippingLabelProps) => {
  const renderCount = useRef(0);

  // Increment render count to help with animation key
  useEffect(() => {
    renderCount.current += 1;
  }, [content, mcf]);

  // Simple content rendering
  if (justContent) {
    return (
      <span key={renderCount.current} className={className}>
        {content}
      </span>
    );
  }

  // Full shipping label with optional MCF logo
  return (
    <span className={className} key={renderCount.current}>
      <span>Dispatched by : {content}</span>

      {/* {mcf && (
        <Image
          src={getCompressedAssetUrl('/web_v2/ring-buy/amazon-fba-2.png')}
          alt="Fulfillment by Amazon"
          width={70}
          height={20}
          loading="lazy"
        />
      )} */}

      {isMinEstimate && <i className="min-est-dot" aria-hidden="true"></i>}
    </span>
  );
};

// Styled component
export const ShippingLabel = ({ className, ...props }: ShippingLabelProps) => (
  <ShippingLabelBase
    className={
      className ? `${styles.shippingLabel} ${className}` : styles.shippingLabel
    }
    {...props}
  />
);

export default ShippingLabel;
